import * as angular from 'angular';
import 'signalr';

export type SignalRHubProxyFactory = (signalRServerUrl: string, hubName: string) => ISignalRHubProxy;

export interface ISignalRHubProxy {
    on: (eventName: string, callback: Function) => void;
    off: (eventName: string, callback: Function) => void;
    invoke: (methodName: string, ...argument: any[]) => any;
    stop: () => void;
    start: (authToken: string, onError: Function) => void;
}

function factory($rootScope: ng.IRootScopeService, $q: ng.IQService) {
    return function(signalRServerUrl: string, hubName: string): ISignalRHubProxy {
        const connection = $.hubConnection(signalRServerUrl);

        let started = false;

        connection.stateChanged((stateChanged) => {
            const oldStateStr = getConnectionState(stateChanged.oldState);
            const newStateStr = getConnectionState(stateChanged.newState);

            console.log(`signalR oldState: ${oldStateStr}, newState: ${newStateStr}`);

            const retryReconnectionMilliseconds = 3000;

            if (started && stateChanged.newState === SignalR.ConnectionState.Disconnected) {
                console.log(`reconnecting in ${retryReconnectionMilliseconds}ms`);
                setTimeout(async function() {
                    await connection.start();
                    $rootScope.$broadcast('updateUnconfirmedOrdersCount');
                    $rootScope.$broadcast('RefreshAll');
                }, retryReconnectionMilliseconds);
            }
        });

        const getConnectionState = function(n: number) {
            if (SignalR.ConnectionState.Connected === n) {
                return 'Connected';
            }

            if (SignalR.ConnectionState.Connecting === n) {
                return 'Disconnecting';
            }

            if (SignalR.ConnectionState.Disconnected === n) {
                return 'Disconnected';
            }

            if (SignalR.ConnectionState.Reconnecting === n) {
                return 'Reconnecting';
            }

            return 'Unknown';
        };

        const proxy = connection.createHubProxy(hubName);

        // anonymous function to pass any number of args in $scope.$apply
        function clbk(args: IArguments, callback: Function) {
            if (callback) {
                callback.apply(this, args);
            }
        }

        return {
            on(eventName: string, callback: Function) {
                proxy.on(eventName, function() {
                    clbk(arguments, callback);
                    $rootScope.$apply();
                });
            },
            off(eventName: string, callback: Function) {
                proxy.off(eventName, function() {
                    clbk(arguments, callback);
                    $rootScope.$apply();
                });
            },
            invoke(methodName: string, ...argument: any[]) {
                const args = Array.prototype.slice.call(argument);
                args.unshift(methodName);
                const deferred = $q.defer();
                proxy.invoke.apply(proxy, args).then(function(result: any) {
                    deferred.resolve(result);
                }).fail(function(err: any) {
                    deferred.reject(err);
                });
                return deferred.promise;
            },
            stop() {
                started = false; // this order is important here
                connection.stop();
                console.log('stopped');
            },
            start(authToken: string, onError: Function) {
                if (!authToken) {
                    console.log('auth token was not found');
                    return;
                }

                connection.qs = { Auth: authToken };

                connection.start()
                    .fail((error: any) => {
                        console.error(error);
                        onError(error);
                    })
                    .done(() =>  {
                        started = true;
                        console.log('started');
                    });
            }
        };
    };
}

factory.$inject = ['$rootScope', '$q'];

angular.module('app.common').service('signalRHubProxy', factory);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/api/signalRHubProxy.service.ts